import { IBuyPackageData } from '../../../reducers/types';

interface IBuyPackageParams {
  packageId: number;
  autoProlong: boolean;
}

export const getParameters = (data: IBuyPackageData): IBuyPackageParams => {
  const { packageId, autoProlong } = data;

  return { packageId: packageId as number, autoProlong };
};
